<template lang="pug">
  #CustomerTempModel.CustomerModel.CustomerModel-tempModel.overflow-hidden(
    :class="{ 'CustomerModel-active': showModel }"
  )
    .content-header.modal_header.rounded-bottom-1rem.pt-0(
      style="height: 50px;"
    )
      .row.align-items-center.h-100
        .col-10
          h5.mb-0 {{ title }}
        .col-2.d-flex.align-items-center.justify-content-center
          i.iconClose(
            @click="closeModel()"
          )
    .h-100.overflow-hidden(
      style="padding-top: 60px!important;"
    )
      .content.h-100.overflow-auto(
        style="padding-bottom: 70px;"
      )
        .term-area
          p.text-justify 非常歡迎您使用BA  One-On-One服務（下稱「本服務」）「本服務」係由登記於臺灣臺北市信義路5段7號22及23樓之台灣萊雅股份有限公司
            |（統編23991432，下稱「萊雅」或「我們」）所營運。台灣萊雅為提供您更即時且正確之產品及服務訊息，藉由申請LINE個人化服務，向您提供即時之產品行銷資訊、諮詢或其他預約服務。
            |敬請於使用「本服務」前詳閱「本服務」使用條款（下稱「本條款」）。當您開始使用「本服務」，即代表您無保留的接受「本條款」之所有內容，萊雅始提供您存取「本服務」之權限。萊雅得隨時修改「本條款」，基此，您每次進入或使用「本服務」時請檢視「本條款」。「本條款」變更內容後您若繼續使用本站，即視為您已同意遵守並接受變更後之「本條款」之拘束。若您在任何時候不願接受「本條款」，則您不得再使用「本服務」。
            |萊雅將不定期透過「本服務」舉辦競賽與推廣活動，並將另行公告該等競賽及推廣活動所適用之條款與條件。 如對使用「本服務」有任何疑問，您得透過 0800-881-789與我們聯繫。
          h4 1. 進入「本服務」
          p 您必須年滿二十(20)歲才能在「本服務」提供您的個人資料、註冊帳號或進行購物。若您未滿二十(20)歲，您必須取得您的父母／監護人之同意。您的父母／監護人必須閱讀並了解「本服務」所有內容並同意您在「本服務」進行購物、註冊帳號或提供個人資料。當您繼續使用「本服務」，表示您的父母／監護人已經閱讀並了解「本服務」內容並同意您在「本服務」購物、註冊帳號與輸入您的個人資料。
            |進入與使用「本服務」部分內容可能需要您註冊帳號並使用密碼。您有責任維持您的帳號、使用者名稱與密碼之機密性。您有責任提供並維持完整、正確與真實的帳號資訊。您可以透過Email或聯絡客服隨時取消您的帳號。若有任何違反「本條款」規定之情事，我們保留不經通知停止您進入／使用「本服務」之權利（包括但不限於拒絕服務、終止帳號等）。
          p 「本服務」係基於本公司向LINE Corporation（以下簡稱為「LINE」）申請「LINE個人化服務」而得向您提供。若您開始使用「本服務」，則將視為您已完整閱覽且同意包括「LINE 服務條款」、「LINE 隱私權政策)」及其他由LINE發布之規範。若因非可歸責於本公司之事由 （包括但不限於您或LINE依照前述條款、政策、規範或依法令而終止LINE所提供之服務），致無法使用「本服務」時，則您瞭解且同意您不得對因此所造成之任何損失，向本公司請求提供任何的形式之賠償或補償。
          h4 2. 智慧財產
          ul
            li 智慧財產權
              p 本服務」及其所包含之元素，包括但不限於品牌、文字、內容、軟體、影片、音樂、音效、圖像、照片、插圖、藝術作品、影像、名稱、logo、商標、服務標章與其他素材（下稱「內容」）皆受著作權、商標權及／或其他智慧財產權之保護。「內容」包括所屬於萊雅或由萊雅控制者，亦包括所屬第三方或由第三方掌控並授權萊雅使用者。您不得為任何目的（包括但不限於商業目的）將「本服務」（全部或一部）加以複製、重製、重編、分解、拆組、進行反向工程、傳佈、發行、展示、表現、修改、製作衍生作品後上傳、傳輸或以其他方式利用。
              p 所有個別文章、報導與其他「本服務」之構成元素皆可能屬於受著作權保護之作品，您同意遵守「本服務」所有著作權等相關聲明或限制條款。
              p 我們可能於「本服務」授權您下載「本服務」之部份內容（下稱「可下載內容」）。我們僅授權您為個人及私人目的，在免收使用費且受智慧財產權保護之法律條件下，准予您對「可下載內容」之非專屬且不可轉讓之使用權，並嚴格禁止任何再製、陳述、修改或散布「可下載內容」。在您下載或使用「可下載內容」時，即表示您已同意在遵循「本條款」及相關限制之前提下使用。
              p 若我們向您開放在「本服務」編輯照片之權限（特別是針對透過虛擬方式試用產品），您茲此確認並同意「本服務」僅供您個人且在符合「本服務」之預期目的範圍內為您私人所用。您無權使用「本服務」從事可能有損第三方之尊嚴、名譽或權利之行為。您無權在未獲第三方事先明確同意之情況下擅自修改及／或展示第三方之影像，且您無權在未獲我們事先明確同意之情況下擅自修改及／或展示（不論是否透過「本服務」修改或展示）「本服務」之一部或全部內容（尤其是顯示模特兒影像之內容）。
            li 第三方權利
              p 我們茲此提醒您，對於您要在「本服務」發佈或公開之任何內容，您必須確實向相關權利人取得所需之一切核准及授權，包括任何及所有智慧財產權及／或文學、藝術及／或工業財產權，及人格權（包括對某人之肖像權），以便您得以無爭議地使用該等內容。舉例而言，如您要發佈／公開之內容（特別是照片）顯示任何近期建築項目、廣告創作、含有標章（首字母、標誌、品牌顏色碼等）服裝設計之內容，您必須確實取得相關授權。
            li 用戶內容
              p 我們可能於「本服務」提供放置用戶內容（例如文字、照片、影片等，下稱「用戶內容」）之專屬空間。
              p 在您透過「本服務」提交／發佈「用戶內容」時，即表示您以不可撤銷的、免收使用費、長期、非專屬、得在全球使用之方式授權我們重製、複製、展示、使用、修改、調整、編輯、散布、翻譯、從之創造衍生作品、合併於其他作品及在任何及所有媒體（包括但不限於「本服務」）上散布及以其他方式利用此等「用戶內容」（全部或一部）。
              p 上述使用包括授權台灣萊雅或其關係企業、其產品及／或品牌，得在企業內部或外部、為企業或財務溝通目的、廣告、及為所有公共關係、歷史資料或存檔目的使用，尤其是在以下媒體之使用（下稱「媒體」）：
              ul.number
                li 以任何型態發佈，不限次數
                li 紙媒（印刷媒體），不限發行數量
                li 出版，不限發行數量，特別是為了內部溝通目的（包括業務團隊及經銷網絡，如批發商、零售商、代理商等）、活動、會議傳單、商展及展示位…等；企業對企業之溝通、相關領域之媒體，且不限次數及／或發行數量
                li 於電子、IT、數位、多媒體、網際網路及內網等發佈，透過任何網站（不論何種網站及／或媒介，包括社群網路如Facebook、Twitter、YouTube或Dailymotion），不限刊登及傳播次數
                li 透過任何廣告媒體（包括使用於零售通路之廣告及萊雅集團品牌產品上）
              p 您充分了解這些社群網路屬第三方所擁有之平台，故透過這些社群網路散佈或使用之「用戶內容」應受各該社群網路之條款規範管理。是以，對於我們或第三方依據社群網站所制定之條款規範而使用之任何內容，我們不負任何責任，包括但不限於：所使用「內容」之授權範圍、期間及刪除。若有任何第三方針對符合社群網路所定條款使用之「內容」主張任何權利，應由您全權負責。
              p 此外，我們提醒您任何「內容」均有可能被搜尋引擎檢索而使其顯示在「本服務」以外並使他人得知。
              p 在不變動您的肖像或文字之前提下，本授權授予我們可以調整您的「內容」使其符合頁面及／或在我們認為有幫助時釐清「用戶內容」。
              p 使用「用戶內容」可能會附隨著一些匿名資料，例如您居住的城市、國家或年齡、及／或（在您明示授權時）得以識別您的資料，如您的名或您的別稱。
              p 任何由您發佈在「本服務」之「用戶內容」應為您的選擇並由您自行負擔所有責任。然，我們謹此提醒您，任何「用戶內容」不得與所適用之法規、道德標準或「本條款」規定之原則有所牴觸。就此，我們保留在任何時候刪除任何可能不符合「本條款」（包括「行為準則」）之「用戶內容」。
              p 此外，如您訪問／取得／知悉由其他使用者所創作之「用戶內容」，您必須遵守使用者之權利，尤其是非經相關使用者之事前同意，不得重製或散佈透過其他媒體所發佈之「內容」。
          h4 3. 行為準則
          p 我們支持寬容並尊重他人權利之價值觀。因此在使用「本服務」時，您同意：
          ul.number
            li 絕不傳達任何種族主義、暴力、排外、惡意、無禮、猥褻或不合法之言論；
            li 絕不散布任何有害、誹謗、未經授權、惡意或侵害隱私權或肖像權、煽動暴力、種族或民族仇恨、或被認為屬於嚴重不雅或煽動構成犯行或罪行之內容；
            li 絕不利用「本服務」從事政治、宣傳或傳教之行為；
            li 絕不發表任何廣告或促銷與「本服務」所表示之品牌相競爭產品及／或服務之內容；
            li 絕不偏離「本服務」之設置目的，包括但不限於將其用於約會服務；
            li 絕不在未取得當事人之事前明示同意下，散布任何可能直接或間接得以標示及識別當事人之資訊，例如當事人之姓、地址、email、電話號碼；絕不散布扭曲年輕人價值觀之資訊或內容；
            li 絕不散布扭曲年輕人價值觀之資訊或內容；
            li 絕不威嚇或騷擾他人；
            li 絕不從事非法行為，包括但不限於可能侵害任何人在軟體、商標、照片、肖像、文字、影片等之權利；
            li 散布描繪未成年人之內容（包括但不限於照片及影片）。
          p 若您發現「用戶內容」有任何可能縱容違反人道主義、挑起種族仇恨及／或暴力、或涉及兒童色情之情事，您應立即透過0800-881-789通知我們。請在電話中說明您發現該等內容之日期、您的身份、URL、具爭議內容之說明及作者之用戶ID。
          p 若您發現「用戶內容」有任何違反上述原則、或侵害您或任何第三人之權利（例如侵權、侮辱、違反隱私權），您得透過0800-881-789通知我們，或者您亦可以具函寄至下列台灣台北市信義路5段7號22樓之台灣萊雅股份有限公司。請在信件中說明您發現該等內容之日期、您的身份、URL、具爭議內容之說明及作者之用戶ID。
          p 通知內容如不完整，請恕我們或無法受理。警語：您必須確認所舉報／通知之內容屬真實無誤，如係以刪除他人之用戶內容或阻止他人發佈言論為目的而舉報／通知非真實或不正確之資訊時，您必須自行承擔相關法律責任。
          h4 4. 本服務資訊內容
          ul
            li 一般條款
              p 我們提醒您「本服務」所含資訊可能會有不準確及疏忽之情形，尤其因部分資訊係由第三方提供。我們承諾將盡速移除不準確之資訊或修改後使其完整。
            li 產品與服務相關資訊
              p 除非「本服務」另有規定，否則本站向您呈現的產品及服務資訊並不構成銷售要約，僅為我們於「本服務」所在地區經銷產品及服務之一般性陳述。
            li 建議與診斷工具
              p 「本服務」及／或診斷工具所提供之建議，僅為取得化妝品專業建議之簡單模擬。其所提供之指示性資訊在任何情況下均不應取代醫學診斷或臨床諮詢，亦不應取代醫學治療。
              p 因此，我們無法保證您對使用此等工具所產生之建議完全滿意，且無法對於您採納建議後之結果承擔任何責任。
              p 若您需要任何其他資訊或有任何疑問，建議洽詢您的專業醫師。
            li 超連結
              p 「本服務」內之部分連結可能會導引您前往第三方所設網站，或您係自第三方網站連結至「本服務」，第三方網站內容並非我們所能掌控，因此我們不負責此等外連網站內容或其中所包含之其他連結之內容。提供連結至第三方網站之事實，不代表我們對該等網站或其產品、服務背書。因「本服務」（包括其連往外部服務及資源之連結或可從外部存取之連結），其可用性與內容均非我們所得管控者，故任何有關該等服務、資源或連結之意見，您應直接反應給該特定外部服務或資源之管理人員。請您自行選擇是否要瀏覽第三方網站，且您必須自行承擔相關責任。
          h4 5. 個人資料
          p 我們可能會蒐集與您有關的個人資料，特別是當您：（i）註冊使用服務；（ii）下載可下載內容；（iii）登入；（iv）註冊加入遊戲／競賽；（v）寄發電子郵件給我們；（vi）回應投票或調查等。這些個人資料我們將以下列方式持有您的個人資料：電腦系統、電子資料庫、數位化檔案庫、電話錄音、紙本或文件檔。這些保存機制以多種方式來管理，可能是由萊雅內部管理掌控，並在本地保存，或由與我們具有契約關係的協力廠商在本地或海外管理。我們將採取一切合理措施，防止您的個人資料遭到濫用、竄改及遺失，並防止未經授權而取得、修改或揭露。
          p 依據個人資料保護法規定，您有權隨時要求我們揭露、查詢、修正、增加、停止及刪除與您有關之個人資料。若您要行使該權利，請隨時通知我們，並將可以證明個人資料歸屬於您之身分證明文件寄送至以下地址：
          p 台灣台北市信義路5段7號22樓
          p 台灣萊雅股份有限公司
          h4 6. 本服務及本條款修改
          p 我們保留隨時修訂或變更「本服務」之內容、資訊及「本條款」之權利，特別是為了因應政府法令規定或為了提供更佳的網站使用而變更相關內容。修改後的條款內容將公布在「本條款」中，除非相關變更需要您明示同意，否則將不會個別通知您，您應隨時注意相關內容的修改與變更。如您在修改內容生效後仍繼續使用「本服務」，即表示您已經瞭解且同意遵守所有修改或變更。
          h4 7. 網站管理
          p 本服務係由[ 台灣萊雅股份有限公司 ]管理，其登記地址[台灣台北市信義路5段7號22樓，聯繫電話為: +(886-2) 8101-6000 。 
          h4 8. 免責聲明
          p 我們將盡力維持並使您可以在任何時候使用「本服務」。惟我們無法擔保「本服務」之永久連結及使用。換言之，我們會不定期暫時停止「本服務」部分或全部服務，例如為了網站維護等技術性因素。
          p 我們得基於包括但不限於商業策略、消費者及員工權益保護之考量，選擇開放或取消特定使用者全部或部分功能之使用權限、亦得指定所綁定之使用者帳號與美容顧問帳號，或就已綁定之使用者變更美容顧問。
          p 「本服務」及內容均以「現狀(“AS-IS”)」提供。我們聲明（於相關法律許可範圍內內）就「本服務」及其內容並無任何明示或默示之保證，包括但不限於所有內容正確性、無侵害權利及就產品符合特定目的之銷售性及適用性之保證。我們不保證「本服務」及其內容所含功能之承擔責任或賠償責任，亦不保證「本服務」及其內容無任何錯誤或不中斷，且不保證所有瑕疵將被更正，或您對「本服務」的使用將有特定之結果。
          p 萊雅不保證「本服務」與您的電腦設備相容，亦不保證「本服務」或其伺服器可免於任何錯誤或病毒、感染或「木馬程式」，您如因此等特殊情況受有任何損害時，概與萊雅無涉。
          p 我們對於網路、IT或電信網路等之中斷或錯誤無法提供任何保證，故對其所產生之任何損害（包括但不限於以下）不承擔任何責任：
          ul.number
            li 透過網路傳輸及／或接受資料及／或訊息之訊號不佳或中斷；
            li 任何外部侵入或電腦病毒；
            li 接收設備或聯網錯誤；
            li 及任何會阻礙「本服務」正常運作之網路故障
          p 除法律明文禁止之情形外，在任何情況下，萊雅對於您及任何第三人因使用或存取「本服務」所受之任何直接、特殊、間接、必然、持續性、偶然、衍生性或懲罰性支出、損失、費用及損害及所失利益，或其他因任何原因（包含過失）所致之其他損害，不負任何責任。即便萊雅曾被通知該等損害之發生可能。
          p 若您違反本使用條款或於使用本服務時有其他任何違反法令之行為，我們得不經通知取消綁定您的帳號並逕行終止本服務。
          h4 9. 準據法及管轄法院
          p 「本條款」以中華民國法律為準據法。您同意因使用「本服務」之內容、服務所產生、或您在「本服務」所進行的任何交易或行為，以及因「本服務」而產生之一切爭議，以臺灣臺北地方法院為第一審管轄法院。
          p 若您對「本服務」內容或條款有任何疑問，歡迎透過以下方式與我們聯繫：
          p 客服專線：  0800-881-789
          p 地址：台灣台北市信義區信義路五段7號22樓
          p 台灣萊雅股份有限公司

</template>

<script>
import IconCloseUrl from '@/assets/images/icon/icon_close.png';
import $ from 'jquery';

const _ = require('lodash');

export default {
  name: 'termsModel',
  components: {
  },
  props: {
    title: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      showModel: false,
      skillsList: [] //ba選擇的技能 for component
    };
  },
  mounted() {
    this.$EventBus.$on('openTermsModel', () => {
      this.initHandler();
    });
  },
  methods: {
    initHandler() {
      const vm = this;
        vm.openModel();
    },
    openModel() {
      this.showModel = true;
    },
    closeModel() {
      this.$emit('closeModelHandler');
      this.showModel = false;
      $('.icon-back').removeClass('d-none');
    },
  },
  beforeDestroy() {
    this.$EventBus.$off('openTermsModel');
  },
  computed: {
  },
};
</script>

<style lang="scss" scoped>
  @font-face {
      font-family: "icon";
      src: url("../../assets/fonts/icon.eot?hrpp7d");
      src: url("../../assets/fonts/icon.eot?hrpp7d#iefix") format("embedded-opentype"), url("../../assets/fonts/icon.ttf?hrpp7d") format("truetype"), url("../../assets/fonts/icon.woff?hrpp7d") format("woff"), url("../../assets/fonts/icon.svg?hrpp7d#icon") format("svg");
      font-weight: normal;
      font-style: normal;
      font-display: block;
    }

  i {
    /* use !important to prevent issues with browser extensions that change fonts */
    font-family: "icon" !important;
    speak: never;
    font-style: normal;
    font-weight: normal;
    font-variant: normal;
    text-transform: none;
    line-height: 1;
    /* Better Font Rendering =========== */
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-size: 1.2rem;
    margin-bottom: 4px;
  }

  .iconClose:before {
    content: "\e908";
  }
  .border-black{
    border: 0.2rem solid #000;
  }
  .outline-product {
    display: block;
    border-radius: 1rem;
    padding: 1rem;
    cursor: pointer;
  }
  .custom-shadow {
    -webkit-box-shadow: 0.2rem 0.2rem 0 #00000033;
    box-shadow: 0.2rem 0.2rem 0 #00000033;
  }

  .product {
    flex: 0 0 48%;
  }
  .selected{
      background-color: #fe8b8b;
    }
  .product_info {
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    height: 100px;
  }
  .product_info > .col {
    display: flex;
    align-items: center;
  }

  input[type="checkbox"], input[type="radio"] {
    position: absolute;
    width: 1px;
    height: 1px;
    display: none;
    opacity: 0;
  }
  .CustomerModel {
    top: 50px
  }
  .term-area {
    padding: 5% 5% 0 5%;
    h4 {
      font-size: 20px;
      font-weight: bold;
    }
    p {
      font-size: 14px;
      margin-bottom: 5px;
    }
    ul {
      padding-left: 15px;
      font-size: 14px;
      list-style-type: lower-alpha;
      .number {
        list-style-type: decimal;
        font-size: 12px;
      }
    }
  }
</style>

<style lang="scss">
  .CustomerModel {
    top: 50px
  }
  .el-radio {
    padding-top: 8px;
  }
  .el-cascader-menu {
    min-width: 40vw;
    max-width: 160px;
  }
  .el-cascader-node {
    padding-left: 10px;
  }
  .el-input__inner {
    border-radius: 20px;
    background-color: #eee;
  }
  .el-cascader-node__label {
    padding: 0;
  }
  .el-icon-circle-close {
    color: #333;
  }
  /*Fixes double tap on iOS*/
  .el-scrollbar {
    > .el-scrollbar__bar {
      opacity: 1 !important;
    }
  }
</style>
